import React from "react";
import { motion } from "framer-motion";
import { FaRocket, FaShieldAlt } from "react-icons/fa";
import Button from "../common/Button";

const CTASection = () => {
  return (
    <section
      id="cta"
      className="py-20 bg-gradient-to-b from-gray-800 via-gray-900 to-gray-800 relative overflow-hidden"
    >
      {/* Background pattern */}
      <div className="absolute inset-0 bg-hero-pattern opacity-5"></div>

      <motion.div
        className="container mx-auto px-4 relative z-10"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="max-w-4xl mx-auto text-center">
          {/* Main content with glass effect */}
          <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-12 shadow-2xl">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <FaShieldAlt className="text-6xl text-blue-400 mx-auto mb-6" />
            </motion.div>

            <motion.h2
              className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
            >
              Ready to Secure Your Cloud Infrastructure?
            </motion.h2>

            <motion.p
              className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              Let's work together to build robust, secure cloud-native
              applications and protect your digital assets.
            </motion.p>

            <motion.div
              className="flex flex-col sm:flex-row gap-4 justify-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
            >
              <Button
                variant="primary"
                size="lg"
                icon={<FaRocket />}
                onClick={() => (window.location.href = "/contact")}
              >
                Get in Touch
              </Button>

              <Button
                variant="secondary"
                size="lg"
                icon={<FaShieldAlt />}
                onClick={() => (window.location.href = "/projects")}
              >
                View My Work
              </Button>
            </motion.div>

            {/* Stats */}
            <motion.div
              className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-400">10+</div>
                <div className="text-gray-400">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-purple-400">100+</div>
                <div className="text-gray-400">Projects Secured</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-green-400">$500K+</div>
                <div className="text-gray-400">Saved for Clients</div>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default CTASection;
